var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('Header',{ref:"head",staticClass:"Header"}),_c('Sidebar',{attrs:{"h_height":_vm.h_height}},[_c('router-view',{key:_vm.$route.query.deviceId,staticClass:"router-view"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }